import { StyleFn } from './index'

export type StylesKeys = 'waveform'

export type StylesObj = {
  [key in StylesKeys]?: StyleFn
}

export type Styles = {
  waveform: StyleFn
}

export const defaultStyles: Styles = {
  waveform: () => ({
    position: 'relative',
    width: '100%',
    gridArea: 'wav',
  }),
}
